module.exports = __webpack_public_path__ + "assets/img/1688icon.7ec697b9.svg";